<template>
	<AwardsSection />
	<TearingDownBarriersSection />
	<AssetClassesSection />
	<ExploreTechnologySection />
	<WaysToInvestSection />
	<CtaSection />
	<GetTheAppSection />
</template>

<script setup lang="ts">
import AssetClassesSection from '@components/marketing-site/asset-classes-section.vue';
import AwardsSection from '@components/marketing-site/awards-section.vue';
import CtaSection from '@components/marketing-site/cta-section.vue';
import ExploreTechnologySection from '@components/marketing-site/explore-technology-section.vue';
import GetTheAppSection from '@components/marketing-site/get-the-app-section.vue';
import TearingDownBarriersSection from '@components/marketing-site/tearing-down-barriers-section.vue';
import WaysToInvestSection from '@components/marketing-site/ways-to-invest-section.vue';
</script>
